export class CustomerItemOrderGuide {
    buyerCustomerSiteId: number;
    buyerCustomerName: string;
    selected: boolean;
    buyerCustomerAccountId: number;
    buyerAcronym: string;
    priceGroupId: number;
}